export default {
  computed: {

  },
  data() {
    return {

    }
  },
  methods: {
    convertDateFormat(inputDateString, separator='-'){
      // inputDateString format e.g. "25-May-2023"
      // console.log('convertDateFormat(inputDateString){');
      // console.log(inputDateString);

      // Helper function to map month name to month number
      const getMonthNumber = (monthName) => {
        const monthNames = [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        return monthNames.indexOf(monthName);
      };

      // Split the date string by the hyphen (-) to extract the day, month, and year
      const parts = inputDateString.split(separator);
      const day = parseInt(parts[0], 10);
      const monthName  = parts[1];
      const year = parseInt(parts[2], 10);

      const month = getMonthNumber(monthName);

      // console.log(parts, day, month, year);

      // Create a new Date object by specifying the year, month (zero-based), and day
      const dateObject = new Date(year, month, day);

      const newDay = ("0" + dateObject.getDate()).slice(-2);
      const newMonth = ("0" + (dateObject.getMonth() + 1)).slice(-2);
      const newYear = dateObject.getFullYear();

      // Format the date to the desired format "YYYY-MM-DD"
      const formattedDate = newYear + '-' + newMonth + '-' + newDay;

      // console.log(formattedDate);

      return formattedDate;
    },
    convertToggle( theData = '', isToDB = false ) {
      // console.log ('convertToggle');
      // console.log (theData + ' <> ' + isToDB);
      
      if ( isToDB ) {
        return (theData == false) ? 0 : 1;  
      } else {
        return (theData == 0) ? false : true;
      }      
    },
    scGetCurrentDate( separator='-' ) {
      let currDate = new Date();
      const currentYear = currDate.getFullYear();
      const currentMonth = String(currDate.getMonth() + 1).padStart(2, '0');
      const currentDay = String(currDate.getDate()).padStart(2, '0');
      return currentYear + separator + currentMonth + separator + currentDay;
    },
    msg_notify_sembcorp() {
      this.$notify({
        message:
          '<b>System Warning : </b> - There is an error with your submission. Please contact Sembcorp staff you know or email to sembsolar.momens@sembcorp.com',
        timeout: 15000,
        icon: 'ni ni-bulb-61',
        type: 'warning',
      });
    },
    msg_notify_ok( message = '') {
      this.$notify({
        message: message,
        timeout: 10000,
        icon: 'ni ni-bell-55',
        type: 'default',
      });
    },

    //_ DEV
    devMsg(isDebug=false, theMsg, theOption='') {
      if ( isDebug ) {
        ( theOption == 'gs' ) ? console.group() : '';
        console.log(theMsg);
        ( theOption == 'ge' ) ? console.groupEnd() : '';
      }
    },

  },

}